import { useTranslation } from 'react-i18next';

import { i18nNS } from '../../../../../../i18n';
import { AttendancePageScreens } from '../../types';
import { Heading } from './styles';
import useAttendanceTitle from './vm';
import { format } from '../../../../../../utils/datetime';

const AttendanceTitle = () => {
  const { t } = useTranslation([i18nNS.CLASS]);

  const { currentScreen } = useAttendanceTitle();

  switch (currentScreen) {
    case AttendancePageScreens.RECORDING_ATTENDANCE:
      return <Heading>{t('recording_attendance', { ns: i18nNS.CLASS })}</Heading>;
    case AttendancePageScreens.ATTENDANCE_RECORDED:
      return <Heading>{t('attendance_recorded', { ns: i18nNS.CLASS })}</Heading>;
    case AttendancePageScreens.RECORD_ATTENDANCE:
    default:
      return (
        <Heading>
          {t('time_to_record_attendance', {
            ns: i18nNS.CLASS,
          })}
        </Heading>
      );
  }
};

export default AttendanceTitle;
